'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _reactIntl = require('react-intl');

var _ClickTracker = require('../../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This field is for numberic values only. While it wraps 
 * number field which requires the negative and decimal
 * characters, these characters never get pass the regex check and are 
 * inconsequential as a result. 
 */
var IntegerField = function (_React$Component) {
  (0, _inherits3.default)(IntegerField, _React$Component);

  function IntegerField(props) {
    (0, _classCallCheck3.default)(this, IntegerField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IntegerField.__proto__ || (0, _getPrototypeOf2.default)(IntegerField)).call(this, props));

    _this.getThousandSeparator = function () {
      if (_this.props.noSeperator) {
        return '';
      }
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(1000.00);
      return valueString.charAt(valueString.indexOf("1") + 1);
    };

    _this.formatNumber = function (value) {
      if (_this.props.noSeperator) {
        return value.toString();
      }
      var formatNumber = _this.props.intl.formatNumber;


      var newVal = value;
      if (typeof value !== "number") {
        newVal = parseInt(value, 10);
      }
      if (!isNaN(newVal)) {
        return formatNumber(newVal, { maximumFractionDigits: 0 });
      } else {
        return value;
      }
    };

    _this.formatOnFocus = function (value) {
      if (_this.props.noSeperator) {
        return value;
      }
      return value.split(_this.state.thousands).join("");
    };

    _this.getAutomationName = function () {
      return _AutomationName2.default.get('intgr', _this.props.automationName);
    };

    _this.handleChange = function (value) {
      (0, _ClickTracker.addEditTrack)(_this.getAutomationName());
      _this.props.onChange(value);
    };

    _this.state = {
      thousands: _this.getThousandSeparator()
    };
    return _this;
  }

  (0, _createClass3.default)(IntegerField, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_cwUi.CwNumberField, (0, _assign2.default)({}, this.props, {
        regex: '^([\\b0-9])*$',
        cwId: this.getAutomationName(),
        onChange: this.props.onChange ? this.handleChange : undefined,
        formatNumber: this.formatNumber,
        negative: '-',
        thousands: this.state.thousands,
        decimal: '.',
        formatOnFocus: this.formatOnFocus
      }));
    }
  }]);
  return IntegerField;
}(_react2.default.Component);

IntegerField.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string,
  /**
   * A boolean passed down to inform the integer not to format a number with that thousands seperator. 
   */
  noSeperator: _propTypes2.default.bool
}, _cwUi.CwNumberField.propTypes, {
  /**
   * Override required prop from spread, these props should never
   * be set when using the number field as they are set in this 
   * component above
   */
  negative: _propTypes2.default.string,
  decimal: _propTypes2.default.string,
  thousands: _propTypes2.default.string,
  formatNumber: _propTypes2.default.func
});

IntegerField.defaultProps = {
  selectAllOnFocus: true
};

exports.default = (0, _reactIntl.injectIntl)(IntegerField);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/numberfield/IntegerField.js
// module id = 785
// module chunks = 10